import { NavLink } from "react-router-dom";
import { MessageCircle, Car, User, Users } from "lucide-react";
import { ru } from "../locales/ru";
import { useChat } from "../context/ChatContext";
import { useOrders } from "../context/OrdersContext";
import { useAuth } from "../context/AuthContext";

const tabs = [
  { to: "/chats", label: ru.nav.chats, Icon: MessageCircle, testId: "nav-chats" },
  { to: "/contacts", label: ru.nav.contacts, Icon: Users, testId: "nav-contacts" },
  { to: "/orders", label: ru.nav.orders, Icon: Car, testId: "nav-orders" },
  { to: "/profile", label: ru.nav.profile, Icon: User, testId: "nav-profile" },
];

export const BottomNav = () => {
  const chat = useChat();
  const { openCount } = useOrders() || {};
  const { user } = useAuth();
  const totalUnread = chat?.totalUnread || 0;
  const isDriver = user?.roles?.includes("driver");

  const badgeFor = (to) => {
    if (to === "/chats") return totalUnread;
    if (to === "/orders" && isDriver) return openCount || 0;
    return 0;
  };

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] bg-white/90 backdrop-blur-xl border-t border-gray-200 pb-[env(safe-area-inset-bottom)] z-40"
    >
      <div className="flex">
        {tabs.map(({ to, label, Icon, testId }) => {
          const badge = badgeFor(to);
          return (
            <NavLink
              key={to}
              to={to}
              data-testid={testId}
              className={({ isActive }) =>
                `flex-1 flex flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition-colors ${
                  isActive ? "text-black" : "text-gray-400"
                }`
              }
            >
              <span className="relative">
                <Icon size={22} strokeWidth={2} />
                {badge > 0 && (
                  <span
                    data-testid={`${testId}-badge`}
                    className="absolute -top-1.5 -right-2.5 bg-black text-white text-[9px] font-bold min-w-[16px] h-4 px-1 rounded-full flex items-center justify-center"
                  >
                    {badge > 99 ? "99+" : badge}
                  </span>
                )}
              </span>
              {label}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};
